module.exports = __webpack_public_path__ + "img/profil_lapper_celine.b3794692.png";